import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, Input, InputGroup, InputGroupAddon} from 'reactstrap';
import autobind from 'autobind-decorator';
import * as invoices from 'invoices/actions/invoices';


@connect(
    state => {
        return {
            invoices: state.invoices
        }
    },
    dispatch => {
        return {
            setSearchText: searchText => dispatch(invoices.setSearchText(searchText)),
            fetchInvoices: () => dispatch(invoices.fetchInvoices())
        }
    }
)
export default class Search extends Component {

    @autobind
    setSearchText(e) {
        const searchText = e.target.value;
        this.props.setSearchText(searchText);
    }

    @autobind
    resetSearchText() {
        this.props.setSearchText('');
        this.props.fetchInvoices()
    }

    @autobind
    triggerSearch(e) {
        if (e.key === 'Enter') {
            this.props.fetchInvoices()
        }
    }

    render() {
        return (
            <InputGroup>
                <Input
                    placeholder="Suche"
                    type="text"
                    onChange={this.setSearchText}
                    onKeyPress={this.triggerSearch}
                    value={this.props.invoices.searchText}
                />
                <InputGroupAddon addonType='append'>
                    <Button onClick={this.resetSearchText}>
                        Zurücksetzen
                    </Button>
                </InputGroupAddon>
            </InputGroup>

        )
    }

}